import axiosInstance from '@/utils/api.js'

var state = {
  systemUsersShortData: []
}

var getters = {

  SYSTEM_USERS_SHORT_DATA: (state) => {
    return state.systemUsersShortData
  }
}

var mutations = {
  SET_SYSTEM_USERS_SHORT_DATA: (state, payload) => {
    state.systemUsersShortData = payload
  }
}

var actions = {
  GET_SYSTEM_USERS_SHORT_DATA: async (context, payload) => {
    let result = await axiosInstance.get('/users/systemusersshort')
    if (result.status === 200) {
      context.commit('SET_SYSTEM_USERS_SHORT_DATA', result.data)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/users/systemUsersShortData.js